
window.$ = window.jQuery = require('jquery');
require('./web_function')
window.lottie = require('./lottie.min')

import 'jquery-validation';
import 'jquery-validation/dist/additional-methods';

import Swiper from "swiper/bundle";
import 'swiper/css/bundle';
import {gsap} from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger'
import {ScrollToPlugin} from 'gsap/ScrollToPlugin'

gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(ScrollToPlugin)


require('./validation/validation_helper')
require('./validation/additional-methods')
require('jsrender');

require('./dialogs/confirm_dialog')
require('./dialogs/loading_dialog')

window.validateMessage = {
    en: {
        required: "This field is required.",
        email: "Please enter a valid email address.",
    },
    tw:{
        required: "必須填寫",
        email: "請輸入有效的電子郵件"
    }
}

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

window.Swiper         = Swiper;
window.gsap           = gsap;
window.ScrollTrigger  = ScrollTrigger;
window.ScrollToPlugin = ScrollToPlugin;
